import React from "react";

const Eye = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="svg-main-icon"
      width="24px"
      height="24px"
      viewBox="0 0 32 32"
      x="0px"
      y="0px"
    >
      <g data-name="Layer 21">
        <path
          d="M29,14.47A15,15,0,0,0,3,14.47a3.07,3.07,0,0,0,0,3.06,15,15,0,0,0,26,0A3.07,3.07,0,0,0,29,14.47ZM16,21a5,5,0,1,1,5-5A5,5,0,0,1,16,21Z"
          fill="#000000"
          fillRule="nonzero"
        />
        <circle cx={16} cy={16} r={3} fill="#000000" fillRule="nonzero" />
      </g>
    </svg>
  );
};

export default Eye;
